import { useEffect, useState } from "react";
import { Routes, Route, Navigate, BrowserRouter, useLocation } from "react-router-dom";
import AuthLayout from "./layouts/Loggedin/defaultLayout";
import NotAuthLayout from "./layouts/notLoggedin/defaultLayout";
import Login from "./pages/authentication/Login";
import TwoFA from "./pages/authentication/twofa";
import Register from "./pages/authentication/Register";
import NotFound from "./pages/page404/Page404";
import MainPage from "./pages/mainPage/mainPage";
import MyTurns from "./pages/turns/myTurns";
import Turns from "./pages/turns/Turns";
import PlaceStore from "./pages/place/place-store";
import DepartmentStore from "./pages/department/department-store";
import DoctorStore from "./pages/doctor/doctor-store";
import BookAppointment from "./pages/book-appointment/book-appointment";
import ActiveTimesByPlace from "./pages/book-appointment/booking";
import ConfirmAppointment from "./pages/book-appointment/confirm-appointment";
import PlaceProfile from "./pages/place/place-profile";
import DoctorProfile from "./pages/doctor/doctor-profile";
import ShiftManagement from "./pages/shiftsManagement/shifts-managment";
import TurnDetail from "./pages/turns/TurnDetail";
import ClarityScript from "./components/ClarityScript/ClarityScript";
import MyProfile from "./pages/userProfile/MyProfile";
import UserDataAuth from "./layouts/getUserCredentials/UserDataAuth";
import { AOS } from 'aos'

const App = () => {

    const location = window.location.href

    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.token ? true : false);

    useEffect(() => setIsLoggedIn(localStorage.token ? true : false), [location]);

    useEffect(() => AOS?.init(), [])

    const activePage = isLoggedIn ? <AuthLayout><AppRoutes /></AuthLayout> : <NotAuthLayout><AppRoutes /></NotAuthLayout>

    return (
        <BrowserRouter>
            <>{activePage}</>
            <ClarityScript />
            <UserDataAuth />
        </BrowserRouter>
    );
};

const AppRoutes = () => {

    const location = useLocation()

    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.token ? true : false);

    useEffect(() => setIsLoggedIn(localStorage.token ? true : false), [location]);

    return (

        <Routes>

            <Route
                path="/book-appointment"
                element={<BookAppointment />}
            />

            <Route
                path="/booking"
                element={<ActiveTimesByPlace />}
            />

            <Route
                path="/confirm-appointment"
                name="Confirm Appointment"
                element={<ConfirmAppointment />}
            />

            <Route
                path="/place"
                element={<PlaceProfile />}
            />

            <Route
                path="/doctor"
                element={<DoctorProfile />}
            />

            <Route
                path="/profile"
                element={<MyProfile />}
            />

            <Route
                path="/shift-management"
                element={<ShiftManagement />}
            />

            <Route
                path="/"
                name="Main Page"
                element={<MainPage />}
            />

            <Route
                path="/my-turns"
                name="My Turns list Page"
                element={<MyTurns />}
            />

            <Route
                path="/turn"
                name="Show Turn Detail Page"
                element={<TurnDetail />}
            />

            <Route
                path="/turns"
                name="Turns list Page"
                element={<Turns />}
            />

            <Route
                path="/my-profile"
                element={<MyProfile />}
            />

            <Route
                path="/place-store"
                name="Place Store Page"
                element={<PlaceStore />}
            />

            <Route
                path="/department-store"
                name="Department Store Page"
                element={isLoggedIn ? <DepartmentStore /> : <Navigate to={"/login"} />}
            />

            <Route
                path="/doctor-store"
                name="Doctor Store Page"
                element={<DoctorStore />}
            />

            <Route
                path="/404"
                element={<NotFound />}
            />

            <Route path="*" element={<Navigate to="/404" />} />

            <Route
                path="/login"
                name="Loginn Page"
                element={isLoggedIn ? <Navigate to={"/"} /> : <Login />}
            />

            <Route
                path="/twofa"
                name="TwoFA Page"
                element={<TwoFA />}
            />

            <Route
                path="/register"
                name="Registerr Page"
                element={<Register />}
            />

        </Routes>

    );
};

export default App;